
import React, { useEffect } from 'react';
import config from '../config';

const MintSite = () => {

    const redirect = () => {
      window.location.href  = config.embedUrl;
      // console.log("newUrl:" + config.embedUrl);
    }

    useEffect(()=> {
        redirect();
    },[])

  return (
    <div></div>
  )
}

export default MintSite